module.exports = __webpack_public_path__ + "static/media/saffron1.444233a3.jpg";